// extracted by mini-css-extract-plugin
export var box = "_7e-1";
export var checked = "_7e-2";
export var descriptionSpacer = "_7e-9";
export var disabled = "_7e-3";
export var icon = "_7e-6";
export var input = "_7e-0";
export var labelSpacer = "_7e-8";
export var medium = "_7e-5";
export var small = "_7e-4";
export var text = "_7e-7";